export class SearchFilterValue {
    constructor(componentName: string, filterValue: string) {
        this.componentName = componentName;
        this.filterValue = filterValue;
    }
    componentName: string;
    filterValue: string;
}
